import CityPageTemplate from "../city-template/CityPageTemplate";
import { kalamazooConfig } from "./data";

export default function KalamazooPage() {
  return <CityPageTemplate config={kalamazooConfig} />;
}